import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    ordersByReservation: [],
    pendingAccountingOrders: [],
    loading: false
};

const apOrdersSlice = createSlice({
    name: 'apOrders',
    initialState,
    reducers: {
        setOrdersByReservation: (state, action) => {
            state.ordersByReservation = action.payload;
        },
        setPendingAccountingOrders: (state, action) => {
            state.pendingAccountingOrders = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});

export const { setOrdersByReservation, setPendingAccountingOrders, setLoading } = apOrdersSlice.actions;

const EMPTY_ARRAY = [];

export const selectOrdersByReservation = (state) => state.apOrders?.ordersByReservation || EMPTY_ARRAY;
export const selectPendingAccountingOrders = (state) => state.apOrders?.pendingAccountingOrders || EMPTY_ARRAY;
export const selectApOrdersLoading = (state) => state.apOrders?.loading || false;



export default apOrdersSlice.reducer;
